export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9757.7d6885e4.jpg";